import { MenuResponseDto } from '@tiendanube/common';
import axios from 'App/axios';

export const getMenu = async () => {
  const { data } = await axios.get<MenuResponseDto>('v1/settings/menu');
  return data;
};
